export default "__VITE_ASSET__c9077f2b__"